<template>
  <div id="app">
    <f7-statusbar></f7-statusbar>
    <f7-view main url="/"></f7-view>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style lang="scss" scoped>

  div#app /deep/ {

    @media print {

      overflow: visible !important;

      .view {
        overflow: visible;
      }

      #results-page, #results-page * {
        visibility: visible !important;
      }

      #results-page * {
        overflow: hidden;
      }

      #results-page {
        overflow-scrolling: auto;
      }

      #results-page {
        overflow: visible;
        position: relative !important;
        left: 0 !important;
        top: 0 !important;
      }

      .page {
        position: relative !important;
        display: none !important;
      }

      div[data-name="pro"] {
        display: block !important;
      }

      .page > .navbar {
        position: relative !important;
      }

      .page-content {
        overflow: initial;
        padding-top: 0.5cm !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue